<template>
	<UiElement :settings="buttonSettings" tag="button" @changeActive="changeActive" :disabled="disabled">
		<span class="shape" :class="{'right': right}">
			<ButtonShape
				:stroke-width="shapeStyles.borderWidth"
				:stroke-color="shapeStyles.borderColor"
				:fill-color="shapeStyles.backgroundColor"
			/>
		</span>

		<span v-html="content" />

		<span v-if="!content">
			<slot />
		</span>
	</UiElement>
</template>

<script setup>
	import { defineProps, ref, computed, toRefs } from 'vue';
	import { useElementStyles } from '@/composables/useElementStyles';
	import UiElement from '@/components/UI/UiElement.vue';
	import ButtonShape from '@/components/ButtonShape.vue';

	const props = defineProps({
		settings: {
			type: Object,
			required: true,
		},
		body: {
			type: Object,
			required: true,
		},
		right: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		content: {
			type: String,
			default: ''
		}
	});

	const isActive = ref(false);

	const { settings, active } = toRefs(props);
	const { styles } = useElementStyles(settings, (active || isActive));

	const buttonSettings = computed(() => {
		const copy = { ...settings.value };

		delete copy.border;
		delete copy.background;
		delete copy.interactions;

		console.log(copy);

		return copy;
	});
	const shapeStyles = computed(() => {
		const { borderWidth, borderRadius, borderColor, borderStyle, backgroundColor } = styles.value;

		return { borderWidth: borderWidth.replace('px', ''), borderRadius, borderColor, borderStyle, backgroundColor }
	});

	function changeActive(value) {
		isActive.value = value;
	}
</script>

<style lang="scss" scoped>
	button {
		position: relative;
		width: 100%;
		background: none;
	}

	.shape {
		position: absolute;
		left: 0;
		top: 0;
		display: block;
		width: 100%;
		height: 100%;
	}

	*:not(.shape) {
		position: relative;
		z-index: 2;
	}

	.right {
		transform: rotate(180deg);
	}
</style>

